import SignIn from '../../../components/SSO/Signin';
import React from 'react';
import { Route } from 'react-router-dom';
import { ProtectedRoutePropsType } from './types';
import { useLoginToken } from 'modules/hooks';

export const ProtectedRouteSignin: React.FunctionComponent<ProtectedRoutePropsType> =
  ({ path }) => {
    return (
      <Route path={path}>
        <SignIn />
      </Route>
    );
  };
